module.exports = __webpack_public_path__ + "static/media/shiftMove3.578b205b.svg";